var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38924",
    "data-name": "Group 38924",
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.771,
    height: 11.295,
    viewBox: "0 0 5.771 11.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_7787532_next_arrow_direction_down_left_icon",
    "data-name": "7787532_next_arrow_direction_down_left_icon",
    d: "M63.992,23.415l-3.954-3.954a.693.693,0,1,0-.98.98L63.012,24.4a.677.677,0,0,1,0,.98l-3.989,3.989a.693.693,0,1,0,.98.98l3.954-3.954A2.1,2.1,0,0,0,63.992,23.415Z",
    transform: "translate(-58.82 -19.251)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.924f8d1d8479b33691bc04677af53052.svg";
export { ForwardRef as ReactComponent };